import { UserItem } from "shared/api";

export function userInitials(user: UserItem): string {
  const first = user.first_name?.trim();
  const last = user.last_name?.trim();
  if (first || last) {
    return [first?.[0], last?.[0]].filter(Boolean).join("").toUpperCase();
  }
  const u = user.username?.trim();
  if (!u?.length) return "?";
  return u.length <= 2 ? u.toUpperCase() : u.slice(0, 2).toUpperCase();
}
